/* eslint-disable camelcase */
import { saveAs } from 'browser-filesaver';
/* eslint-disable max-len */
import { token, userId } from '../currentUser/currentUser.reducer';
/* eslint-disable object-curly-newline,no-param-reassign */
import { isLocal } from '../localId/localId';
import { setError, unsetErrors } from './material/material.actions';
import {
  API_CREATE_WORK_ORDER,
  API_LOAD_WORK_ORDER,
  API_LOAD_WORK_ORDERS, API_LOAD_WORK_ORDERS_APPROVED, API_LOAD_WORK_ORDERS_SUBMITTED,
  API_REMOVE_WORK_ORDER,
  API_UPDATE_WORK_ORDER,
  approvedMaterials,
  MATERIAL_SET_NONE,
  NEW_WORK_ORDER,
  noMaterials, noTailgate,
  REDIRECT_TO_NEW, SORT_BY_DATE, SORT_BY_PROJECT_NAME, TAILGATE_SET_ERROR, TAILGATE_SET_NONE, TAILGATE_UNSET_ERRORS,
  UNSET_NEW_ID
} from './workOrders.reducer';
import { BASE_URL } from '../../helpers/api/apiPaths';

export const newWorkOrder = () => ({ type: NEW_WORK_ORDER });
export const setNoMaterials = (id, anyMaterials) => ({ type: MATERIAL_SET_NONE, anyMaterials, id });
export const setNoTailgate = (id, hasTailgate) => ({ type: TAILGATE_SET_NONE, hasTailgate, id });
export const load = id => ({ resourceAction: API_LOAD_WORK_ORDER, id });
export const loadAll = () => ({ resourceAction: API_LOAD_WORK_ORDERS });
export const loadForForeman = id => ({
  resourceAction: API_LOAD_WORK_ORDERS,
  query: '/foreman',
});

export const loadForProjectManager = (type) => {
  let queryString = type ? `/${type}` : "";

  return ({
    resourceAction: API_LOAD_WORK_ORDERS,
    query: `/pm${queryString}`,
  });
};

export const loadForAdmin = (type) => {
  let queryString = type ? `/${type}` : "";
  return ({
    resourceAction: API_LOAD_WORK_ORDERS,
    query: `/admin${queryString}`,
  });
};

export const resendApprovedEmail = (id) =>
    fetch(`${BASE_URL}/workorders/${id}/admin_email`, {
        method: 'post',
        headers: {
            Authorization: token()
        },
    });

export const pdf = (project, date, id, pdf = "pdf") =>
  fetch(`${BASE_URL}/workorders/${id}/${pdf}`, {
    method: 'get',
    headers: {
      Authorization: token(),
      ContentType: 'application/pdf',
    },
  }).then(response => response.blob().then(r => saveAs(r, `${date}_${project}.pdf`)));

export const tailgatePdf = (project, date, id) =>
  fetch(`${BASE_URL}/workorders/${id}/tailgate/pdf`, {
    method: 'get',
    headers: {
      Authorization: token(),
      ContentType: 'application/pdf',
    },
  }).then(response => response.blob().then(r => saveAs(r, `${date}_${project}.pdf`)));

export const unsetTailgateErrors = id => ({ type: TAILGATE_UNSET_ERRORS, id });
export const setTailgateError = id => ({ type: TAILGATE_SET_ERROR, id });

export const save = ({ city, county, id, inspector, notes, project_id, state, wo_date, work_accomplished, tailgate_url, zip, status, tailgate, tailgate_daily_activity, tailgate_safety_hazards }, submit, canNotApprove) => (dispatch, getState) => {
// eslint-disable-next-line camelcase
  const no_materials = noMaterials(getState(), id);
  if (approvedMaterials(getState(), id)) dispatch(unsetErrors());
  else {
    return new Promise((resolve, reject) => {
      dispatch(setError());
      reject();
    });
  }

  const no_tailgate = noTailgate(getState(), id);
  if (no_tailgate || tailgate || tailgate_url) dispatch(unsetTailgateErrors(id));
  else {
    return new Promise((resolve, reject) => {
      dispatch(setTailgateError(id));
      reject();
    });
  }

  if (submit && !status) {
    status = 'submitted';
  } else if (submit && status && !canNotApprove) {
    status = 'approved';
  }

  const resource = {
    city,
    county,
    id,
    inspector,
    notes,
    project_id,
    state,
    wo_date,
    work_accomplished,
    zip,
    status,
    no_tailgate,
    no_materials,
    tailgate,
    tailgate_safety_hazards,
    tailgate_daily_activity,
  };
  return ((isLocal(resource.id))
    ? dispatch({ resourceAction: API_CREATE_WORK_ORDER, resource: { ...resource, employee_id: userId() } })
    : dispatch({ resourceAction: API_UPDATE_WORK_ORDER, resource }));
};

export const redirectToNew = () => ({ type: REDIRECT_TO_NEW });
export const unsetNewId = () => ({ type: UNSET_NEW_ID });
export const sortByProjectName = () => ({ type: SORT_BY_PROJECT_NAME });
export const sortByDate = () => ({ type: SORT_BY_DATE });

export const remove = id => ({ resourceAction: API_REMOVE_WORK_ORDER, id });



// WEBPACK FOOTER //
// ./src/reducers/workOrder/workOrders.actions.js